const Routes = Object.freeze({
    LANDING_PAGE: '/',
    REDIRECT: '/redirect',
    SECURITY_GROUPS: '/security-groups',
    SECURITY_GROUP_CREATE: '/security-groups/create',
    SECURITY_GROUP_EDIT: '/security-groups/:id',
    SECURITY_GROUP_COPY: '/security-groups/copy/:id',
    INVITATION: '/invitations/:id',
    LINK_ACCOUNT: '/invitations/link-account/:id',
    RESET_PASSWORD: '/reset-password/:id',
    REGISTRATION: {
        LANDING: '/register/connect-user/:passedInfo',
        SSO_LINK: '/register/sso-link/:passedInfo',
        SSO_CREATE: '/register/sso-create/:passedInfo',
        SSO_CONFIRM: '/register/sso-confirm/:passedInfo'
    },
    LOGIN: '/login',
    LOGIN_SUCCESS: '/login-success',
    LOGOUT: '/logout',
    AUTH_LOGOUT: '/auth-logout',
    INACTIVE_USER_ERROR: '/error/inactive-user',
    USER_SETTINGS: '/user-settings',
    CLIENT_SELECT: '/client-select',
    COMMUNITY_SIGNIN: '/community/signin',
    USERS: '/users',
});
export default Routes;